// src/pages/Login.jsx

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Typography, Grid } from "antd";
import Cookies from "js-cookie";

import api from "../../services/api";
import { login } from "../../services/authService";
// En lugar de Navbar, importamos HeaderBar
import HeaderBar from "../../components/LoggedOut/HeaderLogic/HeaderBar";
import FooterLogin from "../../components/Shared/FooterLogin";
import "../../styles/Login.css";

const { Title, Text } = Typography;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // ─── Estados mínimos para HeaderBar ───────────────────────────────────────
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [searchText, setSearchText] = useState("");
  const [favoritesCount] = useState(0);

  // Prop getters vacíos (no haremos búsqueda ni abrir drawers en login)
  const handleSearch = () => {};
  const openFavoritesDrawer = () => {};
  const handleLoginNav = () => { navigate("/login"); }; // para no romper la prop
  const handleContactos = () => { navigate("/contacto"); };
  const toggleFilterDrawer = () => {};
  const toggleMenuDrawer = () => {};
  // ─────────────────────────────────────────────────────────────────────────

  const handleLogin = async () => {
    setError("");
    const result = await login(email, password);
    if (result.success) {
      navigate("/dashboard");
    } else {
      setError(result.message);
    }
  };

  useEffect(() => {
    const token = Cookies.get("accessToken");
    if (token) {
      api
        .get("/auth/validate-token/")
        .then(() => navigate("/dashboard"))
        .catch(() => {
          Cookies.remove("accessToken");
          Cookies.remove("refreshToken");
        });
    }
  }, [navigate]);

  return (
    <div className="login-page-wrapper">
      {/* ─── Reemplazamos <Navbar /> por <HeaderBar /> ────────────────────────── */}
      <HeaderBar
        isMobile={isMobile}
        searchText={searchText}
        onSearchTextChange={setSearchText}
        handleSearch={handleSearch}
        favoritesCount={favoritesCount}
        openFavoritesDrawer={openFavoritesDrawer}
        handleLogin={handleLoginNav}
        handleContactos={handleContactos}
        toggleFilterDrawer={toggleFilterDrawer}
        toggleMenuDrawer={toggleMenuDrawer}
      />

      <div className="main-content-login">
        <div className="container-box login-form-container">
          <Form name="login" onFinish={handleLogin}>
            <Title level={2} style={{ textAlign: "center", marginBottom: "20px" }}>
              Iniciar Sesión
            </Title>

            <Form.Item
              name="email"
              rules={[{ required: true, message: "Por favor ingrese su correo electrónico" }]}
            >
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Correo electrónico"
                className="login-input"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: "Por favor ingrese su contraseña" }]}
            >
              <Input.Password
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Contraseña"
                className="login-input"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block className="main-button">
                Iniciar sesión
              </Button>
            </Form.Item>

            <Form.Item>
              <div className="guest-entry-box" onClick={() => navigate("/")}>
                <div className="guest-icon">🚀</div>
                <div>
                  <Text strong className="guest-title">Explorar como invitado</Text>
                  <p className="guest-description">
                    Navega entre miles de productos sin necesidad de registrarte
                  </p>
                </div>
              </div>
            </Form.Item>

            {error && (
              <Text type="danger" className="login-error">
                {error}
              </Text>
            )}
          </Form>
        </div>
      </div>

      <FooterLogin />
    </div>
  );
}
